import { ListingsSearchBarConnected } from '@components/listings-search-bar';
import React, { type FC } from 'react';
import { SearchBarTooltip } from './SearchBarTooltip';
import { SemanticControls } from './SemanticControls';
import Styles from './SemanticSearch.styles.scss';

export interface SemanticSearchProps {
	/**
	 * Hide this input (and its tooltip) while the condensed copy is showing in
	 * the sticky filter row.
	 * `ListingsSearchBarConnected` has a static input `id`, so only one instance
	 * can be mounted at a time.
	 */
	hideSearchBar?: boolean;
}

export const SemanticSearch: FC<SemanticSearchProps> = ({
	hideSearchBar = false,
}) => {
	return (
		<div className={Styles.semanticSearchWrapper}>
			<SemanticControls />
			{!hideSearchBar && (
				<>
					<ListingsSearchBarConnected />
					<SearchBarTooltip />
				</>
			)}
		</div>
	);
};
